import { render } from "./webNewbill.vue?vue&type=template&id=58b775c5&scoped=true"
import script from "./webNewbill.vue?vue&type=script&lang=js"
export * from "./webNewbill.vue?vue&type=script&lang=js"

import "./webNewbill.vue?vue&type=style&index=0&id=58b775c5&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b775c5"]])

export default __exports__